import React from "react";
/*import { isAndroid, isIOS } from "react-device-detect";*/
import {Route} from "react-router-dom";
import SimCartBanner from "../simCart";
class AppStore extends React.Component {
    constructor(props) {
        super();
        this.state = { ...props };
    }
    componentWillMount() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            console.log("Windows Phone");
        }

        if (/android/i.test(userAgent)) {
            //window.location = "https://play.google.com/store/apps/developer?id=MightyWifi&hl=en_US";
            //window.location = "https://play.google.com/store/apps/details?id=com.hqylkj.lc.Trueposa&hl=en_US";
            window.location = "https://play.google.com/store/apps/details?id=com.hqylkj.lc.mightywifi";
        }

        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            window.location = "https://apps.apple.com/us/app/mightywifi/id1459407290";
        }
    }
    render() {
        return (
            <div></div>
        );
    }
}

export default AppStore;



// WEBPACK FOOTER //
// ./src/pages/appStore/index.js